import { Component, Inject, OnInit, AfterViewInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

@Component({
  selector: 'app-pre-retirement-healthcare-expenses',
  templateUrl: './pre-retirement-healthcare-expenses.component.html',
  styleUrls: ['./pre-retirement-healthcare-expenses.component.scss']
})
export class PreRetirementHealthcareExpensesComponent implements OnInit, AfterViewInit {
  chart: any;
  expenses: any;
  expenseDetails: any;

  constructor(@Inject(MAT_DIALOG_DATA) data, private dialogRef: MatDialogRef<PreRetirementHealthcareExpensesComponent>) {
    this.expenses = data.expenses;
    this.expenseDetails = data.expenseDetails;
  }

  ngOnInit(): void {
    //this.lineChartData();
  }

  ngAfterViewInit(){
    //had to set this because of how graph is loaded in modal
    setTimeout( () => { this.lineChartData(); }, 50 );
  }

  onClose() {
    this.dialogRef.close();
  }

  lineChartData() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }

    let data = [];

    am4core.addLicense("CH134621715");
    this.chart = am4core.create("chartdiv", am4charts.XYChart);

    for (var i = 0; i < this.expenses.length; i++) {
      data.push({ label: this.expenses[i].label, value: this.expenses[i].totalCost });
    }

    // console.log(this.expenses);

    this.chart.data = data;
    var dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.minGridDistance = 60;
    dateAxis.renderer.grid.template.strokeWidth = 0;

    var valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.unit = "$";
    valueAxis.unitPosition = "left";

    var series = this.chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = "value";
    series.dataFields.dateX = "label";
    series.tooltipText = "{value}"
    series.fill = am4core.color("#00D992");
    series.tooltip.pointerOrientation = "vertical";
    series.stroke = am4core.color('#00D992');
    this.chart.legend = new am4charts.Legend();
    this.chart.legend.labels.template.text = "Household OOP healthcare spend [bold {color}]{name}[/]";
    this.chart.cursor = new am4charts.XYCursor();
    this.chart.cursor.snapToSeries = series;
    this.chart.cursor.xAxis = dateAxis;
    this.chart.cursor.behavior = "none";
    this.chart.legend.itemContainers.template.clickable = false;
    this.chart.legend.itemContainers.template.focusable = false;
    this.chart.legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default;
    this.chart.numberFormatter.numberFormat = '$#,###.';
    //this.chart.cursor.dx = 64;
    //this.chart.cursor.dy = -24;
  };
}
